var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotosMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.stp0{fill:#FFFFFF;}\n\t.stp1{fill:#FF7E7B;}\n\t.stp2{fill:#FF6F3F;}\n\t.stp3{fill:#FFAC00;}\n\t.stp4{fill:#FFC300;}\n\t.stp5{fill:#FF3400;}\n\t.stp6{fill:#F0EA0D;}\n\t.stp7{fill:#DAE411;}\n\t.stp8{fill:#EAA200;}\n\t.stp9{fill:#E63300;}\n\t.stp10{fill:#83D567;}\n\t.stp11{fill:#A2DD50;}\n\t.stp12{fill:#8BC100;}\n\t.stp13{fill:#8D8800;}\n\t.stp14{fill:#44C899;}\n\t.stp15{fill:#4EBFBD;}\n\t.stp16{fill:#00A33F;}\n\t.stp17{fill:#008D08;}\n\t.stp18{fill:#859ED5;}\n\t.stp19{fill:#6EACDF;}\n\t.stp20{fill:#1D7B97;}\n\t.stp21{fill:#00683A;}\n\t.stp22{fill:#BE85C1;}\n\t.stp23{fill:#AB86C4;}\n\t.stp24{fill:#5D53A6;}\n\t.stp25{fill:#243F76;}\n\t.stp26{fill:#F1648A;}\n\t.stp27{fill:#E275A8;}\n\t.stp28{fill:#E40017;}\n\t.stp29{fill:#E60000;}\n\t.stp30{fill:#9F3174;}\n\t.stp31{fill:#9F0017;}\n\t.stp32{fill:#561E5D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols_12_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Graphics-_x2F_-App-Icons-_x2F_-Photos_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Photos-Icon_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "stp0",
    d: "M63.6,5c9,0,13.6,0,18.4,1.5c5.3,1.9,9.5,6.1,11.4,11.4C95,22.8,95,27.3,95,36.4v27.2      c0,9,0,13.6-1.5,18.4c-1.9,5.3-6.1,9.5-11.4,11.4C77.2,95,72.7,95,63.6,95H36.4c-9,0-13.6,0-18.4-1.5C12.7,91.5,8.5,87.3,6.5,82      C5,77.2,5,72.7,5,63.6V36.4c0-9,0-13.6,1.5-18.4C8.5,12.7,12.7,8.5,18,6.5C22.8,5,27.3,5,36.4,5H63.6z",
    id: "path-1_29_"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "stp1",
    d: "M35.8,38c0.9,0,1.7,0.1,2.5,0.3c-0.2-0.8-0.3-1.7-0.3-2.5V23c0-0.6,0.1-1.1,0.1-1.6    c-4.7-3.5-11.4-3.1-15.6,1.1s-4.6,10.9-1.1,15.6c0.5-0.1,1.1-0.1,1.6-0.1H35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp2",
    d: "M49.2,47.7c-0.6,0-1.1-0.1-1.7-0.2c0.1,0.5,0.2,1.1,0.2,1.7c0.3-0.2,0.5-0.4,0.8-0.7    C48.7,48.2,48.9,48,49.2,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp3",
    d: "M48.5,31.5c0.6,0.6,1.2,1.3,1.6,2c0.5-0.7,1-1.4,1.6-2l9-9c0.4-0.4,0.7-0.7,1.1-1C61.2,15.6,56.1,11,50,11    c-6.1,0-11.1,4.5-11.9,10.4c0.5,0.3,0.9,0.7,1.3,1.1L48.5,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp4",
    d: "M51,47.7c-0.3-0.4-0.7-0.8-0.9-1.3c-0.3,0.4-0.6,0.9-0.9,1.3c0.3,0,0.6,0,0.8,0C50.3,47.8,50.7,47.7,51,47.7z    "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp5",
    d: "M38,35.8c0,0.9,0.1,1.7,0.3,2.5c4.6,1,8.2,4.6,9.2,9.2c0.5,0.1,1.1,0.2,1.7,0.2c0.3-0.4,0.7-0.8,0.9-1.3    c-2.5-3.9-2.5-9,0-12.9c-0.5-0.7-1-1.4-1.6-2l-9-9c-0.4-0.4-0.9-0.8-1.3-1.1C38.1,21.9,38,22.4,38,23V35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp6",
    d: "M62,35.8c0,0.9-0.1,1.7-0.3,2.5c0.8-0.2,1.7-0.3,2.5-0.3H77c0.6,0,1.2,0.1,1.8,0.2c3.5-4.7,3.2-11.4-1.1-15.7    c-4.3-4.3-11.1-4.6-15.8-1C62,22,62,22.5,62,23V35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp7",
    d: "M52.3,49c0-0.5,0.1-1,0.2-1.5c-0.5,0.1-1,0.2-1.5,0.2c0.2,0.3,0.5,0.5,0.7,0.8C51.9,48.7,52.1,48.8,52.3,49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp8",
    d: "M51.7,31.5c-0.6,0.6-1.2,1.3-1.6,2c2.5,3.9,2.5,9,0,12.9c0.3,0.4,0.6,0.9,0.9,1.3c0.5,0,1-0.1,1.5-0.2    c1-4.6,4.6-8.2,9.2-9.2c0.2-0.8,0.3-1.7,0.3-2.5V23c0-0.5,0-1-0.1-1.5c-0.4,0.3-0.8,0.6-1.1,1L51.7,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp9",
    d: "M50.1,33.5c-2.5,3.9-2.5,9,0,12.9C52.6,42.5,52.6,37.5,50.1,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp10",
    d: "M52.2,50c0,0.4,0,0.8,0.1,1.2c0.5-0.4,1-0.8,1.5-1.1c-0.5-0.3-1-0.7-1.5-1.1C52.3,49.3,52.2,49.7,52.2,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp11",
    d: "M89,50c0-6-4.4-11-10.2-11.8c-0.3,0.5-0.7,0.9-1.1,1.3l-9,9c-0.6,0.6-1.3,1.2-2,1.6c0.7,0.5,1.4,1,2,1.6l9,9    c0.4,0.4,0.7,0.7,1,1.1C84.5,61,89,56.1,89,50z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp12",
    d: "M64.2,38c-0.9,0-1.7,0.1-2.5,0.3c-1,4.6-4.6,8.2-9.2,9.2c-0.1,0.5-0.2,1-0.2,1.5c0.5,0.4,1,0.8,1.5,1.1    c3.9-2.5,9-2.5,12.9,0c0.7-0.5,1.4-1,2-1.6l9-9c0.4-0.4,0.8-0.9,1.1-1.3C78.2,38.1,77.6,38,77,38H64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp13",
    d: "M61.7,38.3c-4.6,1-8.2,4.6-9.2,9.2C57.1,46.5,60.7,42.9,61.7,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp14",
    d: "M64.2,62c-0.9,0-1.7-0.1-2.5-0.3c0.2,0.8,0.3,1.7,0.3,2.5V77c0,0.6-0.1,1.1-0.1,1.7c4.7,3.7,11.5,3.4,15.9-1    c4.3-4.3,4.7-11.1,1-15.9C78.1,61.9,77.6,62,77,62H64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp15",
    d: "M51.2,52.3c0.4,0,0.9,0.1,1.3,0.2c-0.1-0.4-0.2-0.9-0.2-1.3c-0.2,0.2-0.4,0.3-0.6,0.5S51.4,52.1,51.2,52.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp16",
    d: "M68.7,51.7c-0.6-0.6-1.3-1.2-2-1.6c-3.9,2.5-9,2.5-12.9,0c-0.5,0.3-1,0.7-1.5,1.1c0,0.4,0.1,0.9,0.2,1.3    c4.6,1,8.2,4.6,9.2,9.2c0.8,0.2,1.7,0.3,2.5,0.3H77c0.6,0,1.1-0.1,1.7-0.1c-0.3-0.4-0.6-0.8-1-1.1L68.7,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp17",
    d: "M53.8,50.1c3.9,2.5,9,2.5,12.9,0C62.7,47.6,57.7,47.6,53.8,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp18",
    d: "M49,52.3c0.4,0.5,0.8,1,1.1,1.5c0.3-0.5,0.7-1,1.1-1.5c-0.4,0-0.8-0.1-1.2-0.1C49.7,52.2,49.3,52.3,49,52.3z    "
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp19",
    d: "M51.7,68.7c-0.6-0.6-1.2-1.3-1.6-2c-0.5,0.7-1,1.4-1.6,2l-9,9c-0.4,0.4-0.9,0.8-1.3,1.1C39,84.6,44,89,50,89    c6.1,0,11-4.5,11.9-10.3c-0.4-0.3-0.8-0.6-1.1-1L51.7,68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp20",
    d: "M62,64.2c0-0.9-0.1-1.7-0.3-2.5c-4.6-1-8.2-4.6-9.2-9.2c-0.4-0.1-0.9-0.2-1.3-0.2c-0.4,0.5-0.8,1-1.1,1.5    c2.5,3.9,2.5,9,0,12.9c0.5,0.7,1,1.4,1.6,2l9,9c0.4,0.4,0.7,0.7,1.1,1c0.1-0.6,0.1-1.1,0.1-1.7V64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp21",
    d: "M61.7,61.7c-1-4.6-4.6-8.2-9.2-9.2C53.5,57.1,57.1,60.7,61.7,61.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp22",
    d: "M47.7,51c0,0.5-0.1,1-0.2,1.5c0.5-0.1,1-0.2,1.5-0.2c-0.2-0.2-0.3-0.4-0.5-0.6C48.2,51.5,48,51.3,47.7,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp23",
    d: "M38,64.2c0-0.9,0.1-1.7,0.3-2.5c-0.8,0.2-1.7,0.3-2.5,0.3H23c-0.5,0-1,0-1.5-0.1c-3.7,4.7-3.3,11.5,1,15.8    c4.3,4.3,11,4.6,15.7,1.1C38.1,78.2,38,77.6,38,77V64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp24",
    d: "M48.5,68.7c0.6-0.6,1.2-1.3,1.6-2c-2.5-3.9-2.5-9,0-12.9c-0.3-0.5-0.7-1-1.1-1.5c-0.5,0-1,0.1-1.5,0.2    c-1,4.6-4.6,8.2-9.2,9.2c-0.2,0.8-0.3,1.7-0.3,2.5V77c0,0.6,0.1,1.2,0.2,1.8c0.5-0.3,0.9-0.7,1.3-1.1L48.5,68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp25",
    d: "M50.1,66.7c2.5-3.9,2.5-9,0-12.9C47.6,57.7,47.6,62.7,50.1,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp26",
    d: "M47.7,49.2c-0.4,0.3-0.8,0.7-1.3,0.9c0.4,0.3,0.9,0.6,1.3,0.9c0-0.3,0.1-0.7,0.1-1    C47.8,49.7,47.7,49.4,47.7,49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp27",
    d: "M31.5,51.7c0.6-0.6,1.3-1.2,2-1.6c-0.7-0.5-1.4-1-2-1.6l-9-9c-0.4-0.4-0.8-0.9-1.1-1.3    C15.5,38.9,11,43.9,11,50c0,6.1,4.6,11.2,10.5,11.9c0.3-0.4,0.6-0.8,1-1.1L31.5,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp28",
    d: "M31.5,48.5c0.6,0.6,1.3,1.2,2,1.6c3.9-2.5,9-2.5,12.9,0c0.4-0.3,0.9-0.6,1.3-0.9c0-0.6-0.1-1.1-0.2-1.7    c-4.6-1-8.2-4.6-9.2-9.2c-0.8-0.2-1.7-0.3-2.5-0.3H23c-0.6,0-1.1,0.1-1.6,0.1c0.3,0.5,0.7,0.9,1.1,1.3L31.5,48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp29",
    d: "M38.3,38.3c1,4.6,4.6,8.2,9.2,9.2C46.5,42.9,42.9,39.3,38.3,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp30",
    d: "M35.8,62c0.9,0,1.7-0.1,2.5-0.3c1-4.6,4.6-8.2,9.2-9.2c0.1-0.5,0.2-1,0.2-1.5c-0.4-0.3-0.8-0.7-1.3-0.9    c-3.9,2.5-9,2.5-12.9,0c-0.7,0.5-1.4,1-2,1.6l-9,9c-0.4,0.4-0.7,0.7-1,1.1C22,62,22.5,62,23,62H35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stp31",
    d: "M33.5,50.1c3.9,2.5,9,2.5,12.9,0C42.5,47.6,37.5,47.6,33.5,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M38.3,61.7c4.6-1,8.2-4.6,9.2-9.2C42.9,53.5,39.3,57.1,38.3,61.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotosMobile);
export default __webpack_public_path__ + "static/media/photos-mobile.cc63f477c67325c3fcdb0bb74daa0392.svg";
export { ForwardRef as ReactComponent };